/**
 * SandboxBanner — пользовательский баннер «демо-режим».
 *
 * Когда Supabase не настроен, приложение работает на локальных данных и
 * демо-заявках. Этот баннер сообщает об этом пользователю обычными словами,
 * без инженерной терминологии (sandbox / local mode / debug), чтобы UX
 * соответствовал требованиям пилота (Block 9 — UX language hygiene).
 *
 * Не рендерится когда Supabase настроен (isSupabaseConfigured === true).
 */

import { useState } from 'react';
import { isSupabaseConfigured } from '../../domains/auth/supabaseClient';
import { C, F } from '../tokens';

export function SandboxBanner() {
  const [dismissed, setDismissed] = useState(false);

  // В production-режиме (с подключённым сервером) баннер не показываем.
  if (isSupabaseConfigured) return null;
  if (dismissed) return null;

  return (
    <div
      role="status"
      aria-label="Демо-режим"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#7c3700',
        borderBottom: '1px solid #a84d00',
        padding: '6px 14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        minHeight: 34,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <span style={{ fontSize: 13, flexShrink: 0 }}>🧪</span>
        <span
          style={{
            fontSize: 11,
            fontFamily: F.head,
            fontWeight: 700,
            color: '#ffb347',
            letterSpacing: '.3px',
            lineHeight: 1.4,
          }}
        >
          ДЕМО-РЕЖИМ
        </span>
        <span
          style={{
            fontSize: 10,
            color: 'rgba(255,179,71,0.7)',
            fontFamily: F.body,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          Сервер не подключён — изменения сохраняются только на этом устройстве
        </span>
      </div>

      <button
        onClick={() => setDismissed(true)}
        aria-label="Скрыть баннер"
        style={{
          background: 'none',
          border: 'none',
          color: 'rgba(255,179,71,0.6)',
          fontSize: 16,
          cursor: 'pointer',
          padding: '0 2px',
          lineHeight: 1,
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
